import React from 'react';
import * as msgpub from "msgpub";
import {ButtonG, Heading} from '../Common';
import { TextInput, Box, Grid, Select } from 'grommet';
import { HeaderStyleForGrommet, MainStyleForGrommet } from '../../constant/Styles';
import { anyCallBackFunction, searchText } from '../../common/AdminMqtt';
import { DisabelesAdminContext } from '../../constant/AdminMqtt';
import { status_mapper } from '../../common/common';


export default function TokenComponent(props: {admin?: msgpub.Admin, setLog: any}) {
    const {admin, setLog} = props;
    const [token, setToken] = React.useState("");
    const [duration, setDuration] = React.useState("");
    const [user, setUser] = React.useState("");
    const [userList, setUserList] = React.useState<Array<string>>([]);
    const [searchedUserList, setSearchedUserList] = React.useState<Array<string>>([]);
    const disables = React.useContext(DisabelesAdminContext);

    const get = () => {
        anyCallBackFunction(setUserList,
                            setSearchedUserList,
                            setLog,
                            admin?.setUserInfoCallback.bind(admin),
                            admin?.getUsers.bind(admin),
                            "getUsers"
        );
    };

    const add = () => {
        admin?.addToken({
            token: token,
            user: user,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[addToken operation]status: " + status_mapper(status) + "\n"));
            },
            duration: duration === "" ? 0 : Number(duration)
        });
    };

    const remove = () => {
        admin?.removeToken({
            token: token,
            user: user,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "[removeToken operation]status: " + status_mapper(status) + "\n"));
            }
        });
    };

    const onChangeForToken = (event: React.ChangeEvent<HTMLInputElement>) => {
        setToken(event.target.value);
    }

    const onChangeForDuration = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDuration(event.target.value);
    }

    return (
        <div>
            <Grid
                rows={['auto', 'auto']}
                columns={['auto', 'auto']}
                gap="xsmall"
                areas={[
                    { name: 'header', start: [0, 0], end: [1, 0] },
                    { name: 'main', start: [0, 1], end: [1, 1] },
                ]}
            >
                <Box {...HeaderStyleForGrommet}>
                    <Heading title="token control"/>
                </Box>
                <Box {...MainStyleForGrommet}>
                    <form>
                        <Select
                            placeholder="select user"
                            value={user}
                            onSearch={input => {searchText(input, userList, setSearchedUserList)}}
                            onChange={(event) => {
                                setUser(event.value);
                            }}
                            onOpen={get}
                            options={searchedUserList}
                            disabled={disables.others}
                        />
                        <TextInput placeholder="token" value={token} onChange={onChangeForToken} disabled={disables.others}/>
                        <TextInput placeholder="duration(sec, default: infinite)" value={duration} onChange={onChangeForDuration} disabled={disables.others}/>
                        <ButtonG name="add" callback={add} disabled={disables.others} />
                        <ButtonG name="delete" callback={remove} disabled={disables.others}/>
                    </form>
                </Box>
            </Grid>
        </div>
    );
}
